import angular from 'angular';
import {
  authorizationService, loaderService, orgDataService, userService
} from 'app/services';
import { alerts } from 'app/components/global';
import BlockActiveDirectoryController from './block-active-directory.controller';
import blockActiveDirectoryDirective from './block-active-directory.directive';


export const routeConfigBlockActiveDirectory = {
  template: require('./block-active-directory.html'),
  controller: 'BlockActiveDirectoryController',
  controllerAs: 'bADVM',
};

export default angular.module('app.components.membership.blockActiveDirectory', [
  'ngMessages',
  alerts,
  authorizationService,
  userService,
  loaderService,
  orgDataService
])
  .directive('blockActiveDirectory', blockActiveDirectoryDirective)
  .controller('BlockActiveDirectoryController', BlockActiveDirectoryController)
  .name;

console.log('app.components.membership.blockActiveDirectory created');
